import {ModuleWithProviders, NgModule, Optional, Provider, SkipSelf} from "@angular/core";
import {WorkflowService} from "./workflow.service";
import {RouterModule} from "@angular/router";
import {MdProgressSpinnerModule} from "../misc/progress-spinner";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {WorkflowComponent} from "./workflow.component";
import {WorkflowStepBarComponent} from "./workflow-step-bar.component";
import {WorkflowStatusChangeComponent} from "./workflow-status-change.component";
import {WorkflowNoAccessComponent} from "./workflow-no-access.component";
import {SelectProjectUsersComponent} from "./project/select-project-users.component";
import {PickAssetsOrderComponent} from "./order/pick-assets-order.component";
import {PickAssetsDeployComponent} from "./deployment/pick-assets-deploy.component";
import {ExportFleetInformationComponent} from "./deployment/export-fleet-information.component";
import {ExportSmsConfigComponent} from "./deployment/export-sms-config.component";
import {ConfirmOrderComponent} from "./order/confirm-order.component";
import {AssetSelectionModule} from "../asset-select/asset-selection.module";
import {AdditionalDeviceInfoComponent} from "./project/additional-device-information.component";
import {CreateEmeaContractComponent} from "./project/create-emea-contract.component";
import {PaginationModule} from "../pagination/pagination.module";
import {UserSelectionModule} from "../user-select/user-selection.module";
import {ErrorModule} from "../errors/error.module";
import {BrowserModule} from "@angular/platform-browser";
import {DeliveryOpsInformationComponent} from "./project/delivery-ops-information.component";
import {PurchaseOrderEditGridComponent} from "./purchase-orders/purchase-order-edit-grid.component";
import {PurchaseOrderEditCardComponent} from "./purchase-orders/purchase-order-edit-card.component";
import {DaasDeliveryOpsInformationComponent} from "./project-daas/daas-delivery-ops-information.component";
import {ProjectMissingRolesComponent} from "../project-missing-roles/project-missing-roles.component";
import {FileUploadModule} from "ng2-file-upload";
import {AddAssetsComponent} from "./site/add-assets.component";
import {AddAssetsByDeviceComponent} from "./site/add-assets-by-device.component";
import {UploaderWrapperModule} from "../uploader-wrapper/uploader-wrapper.module";
import {TreeViewModule} from "../tree-view/tree-view.module";
import {OrderFormComponent} from "../order/order-form.component";
import {AddAdditionalDataComponent} from "./site/add-additional-data.component";
import {AddAssetSerialNumberComponent} from "./order/add-asset-serial-numbers.component";
import {AppSettingsModule} from "../app-settings/app-settings.module";
import {DartCorrectionRequestDialogComponent} from "./site/dart-correction-request";
import {ProjectAreaGroupComponent} from "./project/project-area-group.component";
import {ManageDartDealsComponent} from "./project/manage-dart-deals.component";
import {EditShippingLabelsComponent} from "./project/edit-shipping-labels.component";
import {CreateGerpContractComponent} from "./project/create-gerp-contract.component";
import {DartDealImportModule} from "../dart-deal/dartDealImport.module";
import {SampleStepComponent} from "./sample-step.component";
import {HttpHelpersModule} from "../http/http-helpers.module";
import {MicroFormModule} from "../micro-form/micro-form.module";
import {AddressModule} from "../address/address.module";
import {ContactModule} from "../contact/contact.module";
import {ContractAccountModule} from "../contract-account/contract-account.module";
import {DatePickerModule} from "../datepicker/datepicker.module";
import {AssociateStandaloneAccessoriesComponent} from "./deployment/associate-standalone-accessories";
import {AssociateStandaloneAccessoryDialogComponent} from "./deployment/associate-standalone-accessory-dialog.component";
import {DeployDevicesComponent} from "./deployment/deploy-devices.components";
import {ExportPartnerInstallationComponent} from "./deployment/export-partner-installation.component";
import {ImportPartnerInstallationComponent} from "./deployment/import-partner-installation.component";
import {SendDevicesToITSMComponent} from "./deployment/send-devices-to-itsm.component";
import {ItsmDeployedAssetsReportComponent} from "./deployment/itsm-deployed-assets-report.component";
import {MessageToTransitionLeadComponent} from "./deployment/message-to-transition-leads.component";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {UnsavedChangesDialogComponent} from "./unsaved-changes-dialog.component";
import {VerifyAssetsCollectedComponent} from "./deployment/verify-collected-assets.component";
import {WorkflowNotificationDialogComponent} from "./notifications/workflow-notification-dialog.component";
import {WorkflowNotificationService} from "./notifications/workflow-notification.service";
import {ProjectService} from "../project/project.service";
import {DeploymentService} from "../deployment/deployment.service";
import {RoleBlockComponent} from "./role-block.component";
import {AddAssetDialogComponent} from "./site/add-assets-dialog.component";
import {WorkflowJumpComponent} from "./workflow-jump.component";
import {ProjectDetailsComponent} from "./project/project-details.component";
import {ProjectDetailsPmpscComponent} from "./project/project-details-pmpsc.component";
import {FindCustomerITSMDialogComponent} from "./project/project-details-find-customer-dialog.component";
import {ProjectImportStructureComponent} from "./project/project-import-structure.component";
import {SiteDetailsComponent} from "./site/site-details.component";
import {OrderDetails} from "./order/order-details.component";
import {OrderStatusDetailsComponent} from "./order/order-status-details.component";
import {CreateWorkOrders} from "./deployment/create-work-orders.component";
import {InstallationModule} from "../installation-dialog/installation.module";
import {DeploymentDetails} from "./deployment/deployment-details.component";
import {ListEditorModule} from "../list-editor/list-editor.module";
import {SetSiteDesignStepsComponent} from "./site/set-site-design-steps.component";
import {DeviceDefectDetails} from "./device-defect/device-defect-details.component";
import {PickDefectAssetsComponent} from "./device-defect/pick-defect-assets.component";
import {DeviceDefectOverviewComponent} from "./device-defect/device-defect-overview.component";
import {DeviceRelocationDetails} from "./device-relocation/device-relocation-details.component";
import {PickRelocationAssetsComponent} from "./device-relocation/pick-relocation-assets.component";
import {DeviceRelocationOverview} from "./device-relocation/device-relocation-overview.component";
import {SetupDefectDialogComponent} from "./device-defect/setup-defect-dialog.component";
import {SetupRelocationDialogComponent} from "./device-relocation/setup-relocation-dialog.component";
import {ImportITSMSiteDialogComponent} from "../sites/import-itsm-site-dialog.component";
import {PurchaseOrdersSelectDialogComponent} from "./purchase-orders/purchase-orders-select-dialog.component";
import {PurchaseOrdersCreateDialogComponent} from "./purchase-orders/purchase-orders-create-dialog.component";
import {DisableOrderAcceptanceDialogComponent} from "./project/disable-order-acceptance-dialog.component";
import {ProjectOffHoldDialogComponent} from "./project/project-off-hold-dialog.component";
import {BulkOrderWFDetails} from "./bulk-order/bulk-order-details.component";
import {PickDevicesBulkOrderComponent} from "./bulk-order/pick-devices-bulk-order.component";
import {ConfirmBulkOrderComponent} from "./bulk-order/confirm-bulk-order.component";
import {BulkOrderFormComponent} from "./bulk-order/bulk-order-form.component";
import {SiteOverviewComponent} from "./site/site-overview.component";
import {FormHelpersModule} from "../form-helpers/form-helpers.module";
import {PrintPreviewModule} from "../print-preview/print-preview.module";
import {SplitDeviceQuantityDialogComponent} from "../order/split-device-quantity-dialog.component";
import {SelectBundlePartsComponent} from "./device-defect/select-bundle-parts.component";
import {AssetModule} from "../asset/asset.module";
import {EditAccessoryDialogComponent} from "../accessory/edit-accessory-dialog.component";
import {SelectableAccessoryPipe} from "../asset/selectable-accessory.pipe";
import {PlaceBulkOrderComponent} from "./bulk-order/place-bulk-order.component";
import {HelpDialogModule} from "../help-dialog/help-dialog.module";
import {SelectPartnerDialogComponent} from "./deployment/dialog-select-partner.component";
import {DialogShowSiteDifferencesComponent} from "./deployment/dialog-show-site-differences.component";
import {WorkflowBlockedNoticeComponent} from "./workflow-blocked-notice.component";
import {PropertyContainerModule} from "../property-container/property-container.module";
import {DialogRejectOrderComponent} from "./order/dialog-reject-order.component";
import {OrderRejectionMessageComponent} from "./order/order-rejection-message.component";
import {DeploymentRejectionMessageComponent} from "./deployment/deployment-rejection-message.component";
import {RejectProjectDialogComponent} from "./project/reject-project-dialog.component";
import {ProjectRejectionMessageComponent} from "./project/project-rejection-message.component";
import {OrderAcceptanceDisabledMessageComponent} from "./project/order-acceptance-disable-message.component";
import {FixAccessoryDialogComponent} from "./site/fix-accessory-dialog.component";
import {GraphqlCoreModule} from "../graphql/graphql-core.module";
import {CdfModule} from "../cdf/cdf.module";
import {SiteCdfDialogComponent} from "./site/site-cdf-dialog.component";
import {SyncCdfComponent} from "./site/sync-cdf.component";
import {HttpClientModule} from "@angular/common/http";
import {ImportITSMGroupsDialogComponent} from "./project/import-itsm-groups-dialog.component";
import {CreateContractAccountDialogComponent} from "./project/create-contract-account-dialog.component";
import {SelectItsmContactDialogComponent} from "./project/select-itsm-contact-dialog.component";
import {SelectItsmAddressDialogComponent} from "./site/select-itsm-address-dialog.component";
import {IndividualSiteDesignComponent} from "./site/individual-site-design.component";
import {ImportCdfDialogComponent} from "./site/import-cdf-dialog.component";
import {AssetReconciliationModule} from "../asset-reconciliation/asset-reconciliation.module";
import {SelectAccessorySoftwareDialogComponent} from "../asset/select-accessory-software-dialog.component";
import {AddIndividualAssetsDialogComponent} from "./site/add-individual-assets-dialog.component";
import {ProjectDetailsDaasComponent} from "./project-daas/project-details-daas.component";
import {DaasProjectSummaryComponent} from "./project-daas/daas-project-summary.component";
import {ManageDartDealsDaasComponent} from "./project-daas/manage-dart-deals-daas.component";
import {LocalizationCodeInput} from "./project/localization-code-input.component";
import {DaasAdditionalDeviceInfoComponent} from "./project-daas/daas-additional-device-information.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {ProjectDetailsDmpsComponent} from "./project/project-details-dmps.component";
import {SelectStagingWarehouseDialogComponent} from "./order/select-staging-warehouse-dialog.component";
import {AssetStatusCardComponent} from "./order/asset-status-card.component";
import {PurchaseOrdersDartOffersSelectDialogComponent} from "../purchase-order/purchase-orders-dart-offers-select-dialog.component";
import {CatalogService} from "../catalog/catalog.service";
import {SelectAssetAssociationDialogComponent} from "../asset/select-asset-association-dialog.component";
import {HighRadiusLogDialogComponent} from "../high-radius/high-radius-log-dialog.component";
import {ProjectCustomerErrorMessagesDialogComponent} from "../project/project-customer-error-messages-dialog.component";
import {FindCustomerOpportunityGroupITSMDialogComponent} from "./project/project-details-find-customer-opportunity-group.component";
import {GlobalDealClassificationDialogComponent} from "./project/global-deal-classification-dialog.component";
import { GlobalDealC2CClassificationDialogComponent } from "./project/global-deal-c2c-classification-dialog.component";
import {SearchSoldtoInOtherCountriesInfoComponent} from "./project/search-soldto-in-other-countries-info.component";
import {ConvertToXlsxDialogComponent} from "./deployment/dialog-convert-to-xlsx.component";
import {TextDialogComponent} from "../text-dialog/text-dialog.component";
import {FleetSelectDialogComponent} from "./fleet/fleet-select-dialog.component";
import {FleetCreateDialogComponent} from "./fleet/fleet-create-dialog.component";
import {CAAcknowledgmentDialogComponent} from "../contract-account/ca-acknowledgment-dialog.component";
import {PCAcknowledgmentDialogComponent} from "./deployment/pc-acknowledgement/pc-acknowledgment-dialog.component";

@NgModule({
  providers: [
    WorkflowService,
    WorkflowNotificationService,
    ProjectService,
    DeploymentService,
    CatalogService,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    HttpHelpersModule,
    MdProgressSpinnerModule,
    PaginationModule,
    UserSelectionModule,
    AssetSelectionModule,
    ErrorModule,
    AddressModule,
    ContactModule,
    ContractAccountModule,
    RouterModule,
    UploaderWrapperModule,
    AppSettingsModule,
    FileUploadModule,
    DartDealImportModule,
    MicroFormModule,
    DatePickerModule,
    BootstrapModalModule,
    InstallationModule,
    TreeViewModule,
    ListEditorModule,
    FormHelpersModule,
    PrintPreviewModule,
    AssetModule,
    HelpDialogModule,
    PropertyContainerModule,
    GraphqlCoreModule,
    CdfModule,
    NgbModule,
    AssetReconciliationModule,
  ],
  declarations: [
    AssetStatusCardComponent,
    WorkflowComponent,
    WorkflowStepBarComponent,
    WorkflowStatusChangeComponent,
    WorkflowNoAccessComponent,
    SelectProjectUsersComponent,
    PickAssetsOrderComponent,
    ConfirmOrderComponent,
    PickAssetsDeployComponent,
    ExportFleetInformationComponent,
    ExportPartnerInstallationComponent,
    ImportPartnerInstallationComponent,
    ExportSmsConfigComponent,
    SendDevicesToITSMComponent,
    ItsmDeployedAssetsReportComponent,
    MessageToTransitionLeadComponent,
    AdditionalDeviceInfoComponent,
    CreateEmeaContractComponent,
    DeliveryOpsInformationComponent,
    PurchaseOrderEditGridComponent,
    PurchaseOrderEditCardComponent,
    DaasDeliveryOpsInformationComponent,
    ProjectMissingRolesComponent,
    AddAssetsComponent,
    AddAssetsByDeviceComponent,
    OrderFormComponent,
    AddAdditionalDataComponent,
    AddAssetSerialNumberComponent,
    DartCorrectionRequestDialogComponent,
    ProjectAreaGroupComponent,
    ManageDartDealsComponent,
    EditShippingLabelsComponent,
    CreateGerpContractComponent,
    SampleStepComponent,
    AssociateStandaloneAccessoriesComponent,
    DeployDevicesComponent,
    UnsavedChangesDialogComponent,
    SelectPartnerDialogComponent,
    DialogShowSiteDifferencesComponent,
    VerifyAssetsCollectedComponent,
    WorkflowNotificationDialogComponent,
    RoleBlockComponent,
    WorkflowJumpComponent,
    AddAssetDialogComponent,
    SelectAccessorySoftwareDialogComponent,
    AssociateStandaloneAccessoryDialogComponent,
    FixAccessoryDialogComponent,
    ProjectDetailsComponent,
    ProjectDetailsPmpscComponent,
    ProjectDetailsDmpsComponent,
    FindCustomerITSMDialogComponent,
    ProjectImportStructureComponent,
    SiteDetailsComponent,
    SiteCdfDialogComponent,
    OrderDetails,
    OrderStatusDetailsComponent,
    CreateWorkOrders,
    DeploymentDetails,
    SetSiteDesignStepsComponent,
    DeviceDefectDetails,
    PickDefectAssetsComponent,
    DeviceDefectOverviewComponent,
    DeviceRelocationDetails,
    PickRelocationAssetsComponent,
    DeviceRelocationOverview,
    SetupDefectDialogComponent,
    SetupRelocationDialogComponent,
    ImportITSMSiteDialogComponent,
    PurchaseOrdersSelectDialogComponent,
    PurchaseOrdersCreateDialogComponent,
    DisableOrderAcceptanceDialogComponent,
    ProjectOffHoldDialogComponent,
    SiteOverviewComponent,
    SplitDeviceQuantityDialogComponent,
    SelectBundlePartsComponent,
    EditAccessoryDialogComponent,
    SelectableAccessoryPipe,
    BulkOrderWFDetails,
    PickDevicesBulkOrderComponent,
    ConfirmBulkOrderComponent,
    BulkOrderFormComponent,
    PlaceBulkOrderComponent,
    WorkflowBlockedNoticeComponent,
    DialogRejectOrderComponent,
    OrderRejectionMessageComponent,
    DeploymentRejectionMessageComponent,
    RejectProjectDialogComponent,
    ProjectRejectionMessageComponent,
    OrderAcceptanceDisabledMessageComponent,
    SyncCdfComponent,
    ImportITSMGroupsDialogComponent,
    CreateContractAccountDialogComponent,
    SelectItsmContactDialogComponent,
    SelectItsmAddressDialogComponent,
    IndividualSiteDesignComponent,
    ImportCdfDialogComponent,
    AddIndividualAssetsDialogComponent,
    ProjectDetailsDaasComponent,
    DaasProjectSummaryComponent,
    ManageDartDealsDaasComponent,
    LocalizationCodeInput,
    DaasAdditionalDeviceInfoComponent,
    SelectStagingWarehouseDialogComponent,
    PurchaseOrdersDartOffersSelectDialogComponent,
    SelectAssetAssociationDialogComponent,
    HighRadiusLogDialogComponent,
    ProjectCustomerErrorMessagesDialogComponent,
    FindCustomerOpportunityGroupITSMDialogComponent,
    GlobalDealClassificationDialogComponent,
    SearchSoldtoInOtherCountriesInfoComponent,
    ConvertToXlsxDialogComponent,
    GlobalDealC2CClassificationDialogComponent,
    TextDialogComponent,
    FleetSelectDialogComponent,
    FleetCreateDialogComponent,
    CAAcknowledgmentDialogComponent,
    PCAcknowledgmentDialogComponent,
  ],
  exports: [
    WorkflowComponent,
    RoleBlockComponent,
    NgbModule,
  ],
  entryComponents: [
    UnsavedChangesDialogComponent,
    SelectPartnerDialogComponent,
    DialogShowSiteDifferencesComponent,
    WorkflowNotificationDialogComponent,
    AddAssetDialogComponent,
    SelectAccessorySoftwareDialogComponent,
    FixAccessoryDialogComponent,
    DartCorrectionRequestDialogComponent,
    SetupDefectDialogComponent,
    SetupRelocationDialogComponent,
    ImportITSMSiteDialogComponent,
    PurchaseOrdersSelectDialogComponent,
    PurchaseOrdersCreateDialogComponent,
    DisableOrderAcceptanceDialogComponent,
    TextDialogComponent,
    ProjectOffHoldDialogComponent,
    SplitDeviceQuantityDialogComponent,
    EditAccessoryDialogComponent,
    DialogRejectOrderComponent,
    AssociateStandaloneAccessoryDialogComponent,
    RejectProjectDialogComponent,
    SiteCdfDialogComponent,
    ImportITSMGroupsDialogComponent,
    CreateContractAccountDialogComponent,
    FindCustomerITSMDialogComponent,
    SelectItsmContactDialogComponent,
    SelectItsmAddressDialogComponent,
    ImportCdfDialogComponent,
    AddIndividualAssetsDialogComponent,
    SelectStagingWarehouseDialogComponent,
    PurchaseOrdersDartOffersSelectDialogComponent,
    SelectAssetAssociationDialogComponent,
    HighRadiusLogDialogComponent,
    ProjectCustomerErrorMessagesDialogComponent,
    FindCustomerOpportunityGroupITSMDialogComponent,
    GlobalDealClassificationDialogComponent,
    SearchSoldtoInOtherCountriesInfoComponent,
    ConvertToXlsxDialogComponent,
    GlobalDealC2CClassificationDialogComponent,
    FleetSelectDialogComponent,
    FleetCreateDialogComponent,
    CAAcknowledgmentDialogComponent,
    PCAcknowledgmentDialogComponent,
  ],
})

export class WorkflowModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: WorkflowModule,
      providers: [
        {provide: WorkflowService} as Provider,
        {provide: WorkflowNotificationService} as Provider,
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: WorkflowModule) {
    if (parentModule) {
      throw new Error("WorkflowModule is already loaded.  Import it in the main module only.");
    }
  }
}
